// Which colour band a running cycle timer belongs in.
//
// The Production Manager timer used to be binary - green while running, red once it passed the
// assembly's average time - which gave a team leader no notice before a vehicle went over. The
// amber band is that notice.
//
// Both thresholds come from the assembly itself (PartAssembly.AverageAssemblyTime and
// WarningAssemblyTime), so either can be unset. Kept as a pure function rather than inline JSX
// because the ordering rule below is the part that has to be right, and it is worth testing on its
// own.
export type CycleTimeBand = "normal" | "warning" | "over";

export function cycleTimeBand(
  elapsedSeconds: number,
  warningMinutes?: number | null,
  targetMinutes?: number | null
): CycleTimeBand {
  // A zero or negative threshold is a data problem (the field is min=0), not an instruction to
  // flag everything the moment the timer starts, so treat it as unset.
  const overSeconds = targetMinutes && targetMinutes > 0 ? targetMinutes * 60 : null;
  const warnSeconds = warningMinutes && warningMinutes > 0 ? warningMinutes * 60 : null;

  // Red first: an assembly whose target is under its warning time - or under 15 minutes, where
  // the warning is a leftover from a longer target - must still go red rather than sticking on
  // amber. Over always beats warning.
  if (overSeconds !== null && elapsedSeconds > overSeconds) return "over";
  if (warnSeconds !== null && elapsedSeconds > warnSeconds) return "warning";

  return "normal";
}
